import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom"
import { useApi } from "../../../../api"
import { Numeral } from "../../../../components/Numeral";
import { ICargo, INftAsset } from "../../../../interfaces";
import { Utils } from "../../../../utils";

export const NftHomeRecom = () => {
  const projectCode = 'NFT';
  const navi = useNavigate()
  const api = useApi(projectCode);
  const [mounted, setMounted] = useState<Boolean>(false);
  const [ethRate, setEthRate] = useState<number | null>(null);
  const [assets, setAssets] = useState<INftAsset[]>([]);

  useEffect(() => {
    if (mounted) return;
    setMounted(true);

    api.getBinanceTicker('ETH', (cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setEthRate(cargo.info['rate'])
      }
    })
    
    api.getSelectedNft((cargo: ICargo) => {
      if (cargo.returnCode === '000000') {
        setAssets(cargo.info)
      }
    })
  }, [api, assets, mounted])

  return (
    <>
      <div className="d-flex flex-wrap justify-content-center mx-auto" style={{ maxWidth: '1280px' }}>

        {
          assets.map(asset => {
            return (
              <div key={asset.nftId} className="cards d-flex flex-column mx-3 mb-4 w-100" style={{ height: '360px', maxWidth: '360px' }}>
                <div className="d-flex justify-content-center align-items-baseline" style={{ height: '220px' }} onClick={() => {
                  navi(`/web/asset/detail/${asset.nftId}`)
                }}>
                  <img src={Utils().normalizeImagePath(asset.image, projectCode)} alt={asset.name}
                    className="" style={{ height: '100%', maxWidth: 'fit-content' }} />
                </div>
                <div className="p-3 weight-600">{asset.name}</div>
                <div className="d-flex justify-content-between txt-12">
                  <div className="px-3 weight-600">price</div>
                  <div className="d-flex align-items-center me-3">
                    <img src={require("../../../../assets/img/nft/Tether-USDT-icon.png")} alt="" width={'22px'} />
                    <span className="mx-2">$<Numeral value={asset.sellingPrice} /></span>
                    { ethRate && <span>(ETH <Numeral value={asset.sellingPrice / ethRate} />)</span>}
                  </div>
                </div>
                <div className="d-flex justify-between align-items-center px-3 py-2 txt-12">
                  <div className="d-flex align-items-center">
                    <span className="material-icons txt-18 mr-2" style={{ verticalAlign: 'text-bottom',color: '#951dfe' }}>local_mall</span>
                    <span className="text-primary">出價</span>
                  </div>
                  <div className="d-flex align-items-center text-gray-400">
                    <span className="mr-2">{asset.favorite}</span>
                    <span className="material-icons-outlined cursor-pointer" title="加入收藏">favorite_border</span>
                  </div>
                </div>
              </div>
            )
          })
        }
      </div>
    </>
  )
}